// extracted by mini-css-extract-plugin
export default {"modal":"AddTeacherModal_modal__ocl0+","teachername":"AddTeacherModal_teachername__LloNI","submit":"AddTeacherModal_submit__IzNNZ"};